import { render, staticRenderFns } from "./access-google-ads-lang.vue?vue&type=template&id=0308a1b9&scoped=true"
import script from "./access-google-ads-lang.vue?vue&type=script&lang=js"
export * from "./access-google-ads-lang.vue?vue&type=script&lang=js"
import style0 from "./access-google-ads-lang.vue?vue&type=style&index=0&id=0308a1b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0308a1b9",
  null
  
)

export default component.exports